import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const Link = ({ linkText, color, href, onClick, style }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = (event) => {
    // Call the provided onClick function if it exists
    if (onClick) {
      onClick(event);
    }
    // Add additional logic or remove the next line if you don't want to navigate
    // to the href when the link is clicked
    navigate(href);
  };

  const linkStyle = {
    textDecoration: "none",
    color: color,
    cursor: "pointer", // Add this to show that the link is clickable
  };

  return (
    <a
      href={href}
      style={{ ...linkStyle, ...style }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {linkText}
    </a>
  );
};

export default Link;
